import React, { Component } from "react";
import wang from "../../images/wang.jpg";
import wanlapa from "../../images/wanlapa.jpg";
import styles from "./TeamItem.module.scss";
import Img from "gatsby-image";
import { importImages, truncate } from "../../utils/helpers";

class TeamItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showAll: false
		};
	}

	handleTruncate = () => {
		const { showAll } = this.state;

		this.setState({ showAll: !showAll });
	};

	render() {
		const { showAll } = this.state;
		const {
			photo,
			job_title,
			name,
			degree,
			bio,
			email,
			pubMed,
			researchGate,
			mahidolProfile,
			linkedInProfile
		} = this.props;
		const { props } = this;

		return (
			<div className={"col-12 col-md-6 " + styles.member_item}>
				<div className={"row justify-content-between "  + styles.profile_row}>
					<div className={styles.photo_col}>
						{/* <Img title={name} alt={name} sizes={photo.sizes} /> */}
						<img  alt={name} src={photo.sizes.src} />
						<ul className={styles.member_link_list}>
							{props.links &&
								props.links.map((link, i) => {
									return (
										<li
											key={"link-" + (i + 1)}
											className={styles.member_link_item}
										>
											<a
												href={link.url}
												className={styles.member_link}
											>
												{link.label}
											</a>
										</li>
									);
								})}
						</ul>
					</div>
					<div className={styles.profile}>
						<small className={styles.job_title}>{job_title}</small>

						<h4 className={styles.name}>{props.name}</h4>
						<small className={styles.degree}>{degree}</small>
					</div>
					<div className={styles.profile_bio}>
						<p className={styles.description}>
							{props.bio &&
								(!showAll
									? truncate(props.bio, 120, true)
									: props.bio)}{" "}
							{props.bio &&
								props.bio.length > 120 && (
									<button
										onClick={() => this.handleTruncate()}
										className={styles.show_more}
									>
										{!showAll
											? "show more ▾"
											: "« show less"}
									</button>
								)}
						</p>
						<div className={styles.contact_details}>
							{props.email && (
								<span>
									<i className="envelope" />
									{props.email}
								</span>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default TeamItem;



// WEBPACK FOOTER //
// ./src/components/team-item/index.js